module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    on: {
      "touchend": _vm.handleTouchEnd
    }
  }, [_c('dof-overlay', _vm._b({
    ref: "overlay",
    attrs: {
      "show": _vm.overlayShow,
      "canAutoClose": _vm.isOverLayClickHide
    },
    on: {
      "dofOverlayBodyClicked": _vm.dofOverlayBodyClicking
    }
  }, 'dof-overlay', _vm.overlayCfg, false))], 1), (_vm.show_) ? _c('div', {
    ref: "dof-popup",
    class: ['dof-popup', _vm.pos],
    style: _vm.padStyle,
    attrs: {
      "height": _vm._height
    },
    on: {
      "click": function () {}
    }
  }, [_vm._t("default"), (_vm.button && _vm.button.length > 0) ? _c('div', {
    staticClass: ["btnGap"],
    staticStyle: {
      height: "20px"
    }
  }) : _vm._e(), (_vm.button && _vm.button.length > 0) ? _c('div', {
    staticClass: ["midea-actionsheet-bottom"]
  }, _vm._l((_vm.button), function(btn, index) {
    return _c('text', {
      key: index,
      class: ['midea-actionsheet-btn'],
      style: {
        color: btn.hasOwnProperty('textColor') ?
          btn.textColor :
          _vm._isColmo ?
          'rgba(255,255,255,0.80)' :
          index === 0 && !_vm._isDiablo ?
          '#616C73' :
          index === 0 && _vm._isDiablo ?
          '#797c7e' :
          '#00A4F2'
      },
      on: {
        "click": function($event) {
          _vm.actionsheetBtnClick(index, btn.hasOwnProperty('text') ? btn.text : btn)
        }
      }
    }, [_vm._v(_vm._s(btn.hasOwnProperty('text') ? btn.text : btn))])
  })) : _vm._e(), _c('div', {
    style: {
      height: _vm.show && _vm.isipx ? _vm.sageHeight + 'px' : '0px',
      backgroundColor: _vm.safeAreaBgColor ? _vm.safeAreaBgColor : _vm._isColmo ? '#151617' : _vm.padStyle.backgroundColor
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-63c3b709!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-popup/index.vue
// module id = 633
// module chunks = 0 1